module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAAp0lEQVRIx2NgMNb4z9CT+59hZvngxEDwn4GX6z9Dqv8gdiAMG6kPvtBEcSAI83AOrtDEcOBgC02cDoSHpt8gdiAUy5kavC08tvnYQGCiHAjCAwVGHTjqwFEHUsOBlnzCb6+auh8bCIzXgQKMzP87uCX/nxNUGzCM04HObDz/9wgoD6jjsDoQFGqdAxxqOB3owsb7f+8gCDUMBwoOslBDcaDrIAw1ZAwAztxG2kTnI/MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/kw.png
// module id = 319
// module chunks = 0